<template>
  <div class="com-box">
    <img class="head-img" src="https://img3.quanyou.com.cn/joyNew/group1/M00/1D/E2/rB8LrWU6JNSAbYptAABNA3f20ek360.png" alt="" />
    <div class="card">
      <div class="notice-bar">
        <van-notice-bar left-icon="volume-o" :scrollable="false">
          <van-swipe
            vertical
            class="notice-swipe"
            :autoplay="3000"
            :show-indicators="false"
          >
            <van-swipe-item v-for="(item,index) in spikeRolling" :key="index">
              {{`刚刚${item.contactsName}秒杀了${item.goodsName}`}}
            </van-swipe-item>

          </van-swipe>
        </van-notice-bar>
      </div>
      <template v-if="spikeGoods && spikeGoods.length">
        <div class="commodity-box">
          <div class="commodity-item" v-for="(item, index) in spikeGoods" :key="index"  @click="jumpSpikeList">
            <div class="left">
              <van-image class="commdity-img" :src="item.headImg || item.headImgList[0].url" alt="" fit="cover" />
              <span class="tab img-tab" v-if="item.goodsTag">{{item.goodsTag}}</span>
            </div>
            <div class="right">
              <div class="commdity-name">
                <span class="tab name-tab" v-if="item.goodsTag">{{item.goodsTag}}</span>
                <span>{{item.goodName}}</span>
              </div>
              <div class="line">
                <div class="context">
                  <span>剩余100%</span>
                  <img src="https://img3.quanyou.com.cn/joy/group1/M00/16/2F/rB4ChmMbGn2AeDbJAAAIbVv5m_Y203.png" alt="">
                </div>
              </div>
              <div class="min-title">总共1000个，已经有200人参与秒杀</div>
              <div class="price-box">
                <div class="price-left">
                  <div class="original-price">
                    <span class="rmb" v-if="item.spikePrice > 0 ">¥ </span>
                    <span class="money">{{item.spikePrice > 0 ? `${item.spikePrice }` : '免费'}}</span>
                    <span class="text">秒杀价 </span>
                  </div>
                  <div class="seckill-price">¥ {{item.oldPrice}}</div>
                </div>
                <!-- <div class="btn-rigth">抢购</div> -->
                <div class="right" v-if="boolPrePay == 'true'">
                  定金:<span class="number">
                    {{item.preSpikePrice > 0 ? `${item.preSpikePrice }` : '免费'}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <img class="more-img" src="https://img3.quanyou.com.cn/joyNew/group1/M00/1D/B0/rB8LrWU4fFKANNelAAAcWbKOsD0242.png" alt="" />
      </template>
      <img class="placeholder-img" v-else src="https://img3.quanyou.com.cn/joyNew/group1/M00/1D/28/rB8LrWUyIYCABx8sAAFMb4ttLkE613.png" alt="" />
    </div>
  </div>
</template>

<script>
import mixins from './mixins'
export default {
  mixins: [mixins],
}
</script>

<style lang="stylus" scoped>
  .com-box {
    overflow hidden
    .head-img {
      width: 100%;
      height: 50px;
    }
    .card {
      width: 100%;
      min-height: 250px;
      background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1D/E0/rB8LrmU6HjmASdt9AABlB9CuI78816.png');
      background-size: 100% 100%;
      margin-top: -35px;
      overflow: hidden;
      padding-bottom: 30px;
      box-sizing border-box
      .notice-bar {
        width: 319px;
        height: 26px;
        background: #FF8D3F;
        box-shadow: 0px 0px 3px 1px rgba(168,37,0,0.6);
        border-radius: 5px;
        margin: auto;
        margin-top: 36px;
        >>> .van-notice-bar {
          height: 26px;
          color: #FFFFFF;
          font-size: 9px;
          background: transparent;
        }
        .notice-swipe {
          height: 26px;
          line-height: 26px;
        }
      }
      .commodity-box {
        width: 330px;
        border-radius: 5px;
        margin: auto;
        margin-top: 10px;
        .commodity-item {
          display: flex;
          width: 330px;
          height: 123px;
          background: #FFF9EE;
          border-radius: 5px;
          padding: 12px;
          box-sizing: border-box;
          margin-bottom: 10px;
          .tab {
            padding: 1px 4px;
            height: 16px;
            color: #FFEA34;
            font-size: 12px;
            font-weight: bold;
            text-align: center;
            line-height: 16px;
            background: linear-gradient(0deg, #FF4C14 0%, #FF7B36 100%);
          }
          .left {
            position: relative;
            width: 100px;
            height: 100px;
            border-radius: 5px;
            .img-tab {
              display: inline-block;
              position: absolute;
              right: 0;
              bottom: 0;
              border-top-left-radius: 6px;
            }
            .commdity-img {
              width: 100%;
              height: 100%;
              border-radius: 5px;
            }
          }
          .right {
            flex: 1;
            margin-left: 10px;
            .commdity-name {
              color: #222223;
              font-size: 14px;
              font-weight: bold;
              .name-tab {
                border-radius: 2px;
                margin-right: 2px;
              }
            }
            .line {
              width: 100%;
              height: 12px;
              background: #FFC09D;
              border-radius: 5px;
              margin-top: 10px;
              .context {
                position: relative;
                border-radius: 3px;
                height: 12px;
                width: 100%;
                color: #fff;
                font-size: 10px;
                line-height: 11px;
                background: #FF5016;
                span {
                  position: absolute;
                  right: 24px;
                }
                img {
                  width: 20px;
                  height: 20px;
                  right: -4px;
                  top: -4px;
                  position: absolute;
                }
              }
            }
            .min-title {
              color: #AAADB5;
              font-size: 10px;
              font-weight: 500;
              margin-top: 5px;
            }
            .price-box {
              display: flex;
              justify-content: space-between;
              align-items: flex-end;
              margin-top: 10px;
              .price-left {
                display: flex;
                align-items: flex-end;
                .original-price {
                  color: #EE591D;
                  font-weight: bold;
                  .rmb {
                    font-size: 16px;
                  }
                  .money {
                    font-size: 25px;
                  }
                  .text {
                    font-size: 9px;
                    margin-left: 4px;
                  }
                }
                .seckill-price {
                  color: #AAADB5;
                  font-size: 9px;
                  text-decoration: line-through;
                  margin-left: 5px;
                  margin-bottom: 2px;
                }
              }
              .right {
                color: #EE591D;
                font-size: 12px;
                text-align: right;
                .number {
                  color: 14px;
                  font-weight: 14px;
                }
              }
              .btn-rigth {
                width: 68px;
                height: 30px;
                color: #fff;
                font-size: 14px;
                font-weight: 500;
                text-align: center;
                line-height: 30px;
                background: linear-gradient(0deg, #FF4C14 0%, #FF7B36 100%);
                box-shadow: 0px 3px 4px 0px rgba(254,137,49,0.6);
                border-radius: 15px;
              }
              
            }
          }
        }
      }
      .more-img {
        display: block;
        width: 112px;
        height: 36px;
        margin: auto;
        margin-top: 10px;
      }
      .placeholder-img {
        display: block;
        width: 320px;
        height: 255px;
        border-radius: 5px;
        margin: 15px auto;
        // margin-bottom: 20px;
      }
    }
  }
</style>